class ProjectMessageController {
    constructor($scope, toastr, $uibModal, MtMessagesServiceApi, UserDetailsApi, TraceHubExService, SettingsService) {
        this.$onInit = () => {
            this.init();
            this.SettingsService.getSettings().then((response) => {
                const appSettings = response.data;
                // SIGNAL R Section
                this.TraceHubExService.connectWithSpecificTransport('ProjectMessageController', appSettings.SignalRTransport);
                this.TraceHubExService.on('ProjectMessageController', 'onInit', (connId) => {
                    this.state.connectionId = connId;
                });
                this.TraceHubExService.on('ProjectMessageController', 'onNewAttachments', (dto) => {
                    if (dto.ConnectionId !== this.state.connectionId) {
                        return;
                    }
                    if (dto.Attachments.length === 0) {
                        return;
                    }
                    let notes = _.filter(dto.Attachments, (att) => {
                        return att.AttachmentType === 'note';
                    });
                    if (notes.length === 0) {
                        return;
                    }
                    // NOTE: We should only ever get a single message at a time
                    // Now we want to add this note to the beginning of the vm.mtMessages
                    angular.forEach(notes, (note) => {
                        this.MtMessagesServiceApi.mtMessage(note.Id).then((response) => {
                            let msg = response.data;
                            this.mtMessages.splice(0, 0, msg);
                        });
                    });
                });
            });
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop('ProjectMessageController');
        };
        this.$onChanges = (changes) => {
            if (changes.userId) {
                this.userId = angular.copy(changes.userId.currentValue);
                if (angular.isUndefined(this.userId)) {
                    return;
                }
            }
            if (changes.simId) {
                this.simId = angular.copy(changes.simId.currentValue);
                if (angular.isUndefined(this.simId)) {
                    return;
                }
            }
            this.renderProjectMessages(this.userId, this.simId);
        };
        this.init = () => {
            this.UserDetailsApi.get().then((response) => {
                this.userDetails = response.data;
                let isSupporting = this.userDetails.IsSupport || this.userDetails.IsProjectTester;
                if (isSupporting && this.userId) {
                    this.overTheShoulder = true;
                }
                else {
                    this.overTheShoulder = false;
                }
            });
            if (angular.isUndefined(this.userId)) {
                return;
            }
            this.renderProjectMessages(this.userId, this.simId);
        };
        this.renderProjectMessages = (userId, simId) => {
            let req = {
                TesterId: userId,
                ProjectIterationId: -1,
                SimId: simId,
                SuiteId: -1,
                TestId: -1,
                TraceUid: ''
            };
            this.MtMessagesServiceApi.mtMessages(req).then((response) => {
                this.mtMessages = response.data;
            });
        };
        this.openTraceDetails = (msg) => {
            let user = this.userDetails;
            let selectedItems = {
                selectedTester: { Id: msg.UserId, Name: '' },
                selectedSim: { Id: msg.SimId, Name: '' },
                selectedSuite: { Id: msg.TestSuiteId, Name: '' },
                selectedTest: { Id: msg.UserTestCaseId, Name: '' },
                projectIterationId: msg.ProjectIterationId,
                selectedTraceId: -1 // Don't worry about the trace
            };
            let mode = { view: false, run: false };
            let tdParams = {
                selectedItems: selectedItems,
                mode: mode,
                user: user,
                overTheShoulder: this.overTheShoulder
            };
            let modalInstance = this.uibModal.open({
                animation: true,
                size: 'xl',
                backdrop: 'static',
                component: 'traceDetailsModal',
                resolve: {
                    params: () => {
                        return tdParams;
                    }
                }
            });
            modalInstance.result.then(
            // close callback
            function () {
            }, 
            // cancel callback
            function () {
            });
        };
        this.scope = $scope;
        this.toastr = toastr;
        this.uibModal = $uibModal;
        this.MtMessagesServiceApi = MtMessagesServiceApi;
        this.UserDetailsApi = UserDetailsApi;
        this.TraceHubExService = TraceHubExService;
        this.SettingsService = SettingsService;
        this.mtMessages = [];
        this.state = {
            connectionId: ''
        };
    }
}
angular.module('app').component(('projectMessage'), {
    bindings: {
        userId: '<',
        simId: '<'
    },
    controllerAs: 'vm',
    controller: ProjectMessageController,
    templateUrl: 'scripts/app/partials/TestExecution/ProjectTesting/project-message.tpl.html'
});
